import React from 'react';
import { useTranslation } from 'react-i18next';
import UploadDocuments from '../../../Components/UploadDocuments/UploadDocuments';
import { BombiixModal } from '../../../Components/BombiixModal';

/**
 * Spreadsheet import popup in the master-design modal chrome: blue Add on the left,
 * centered title, red close on the right. Body is the shared `UploadDocuments` dropzone.
 * @param {object} props - Component props.
 * @param {boolean} props.showUploadModal - Whether the popup is open.
 * @param {Function} props.closeUploadModal - Closes the popup.
 * @param {object} props.docRef - Ref forwarded to `UploadDocuments` to read the picked file.
 * @param {Function} props.addDocument - Submits the picked file.
 * @param {boolean} props.loader - True while the import request is in flight.
 * @returns {JSX.Element} The import popup.
 */
function ImportModal({ showUploadModal, closeUploadModal, docRef, addDocument, loader }) {
  const { t } = useTranslation('common');

  return (
    <BombiixModal
      size="lg"
      show={showUploadModal}
      title={t('BOM_LIBRARY.IMPORTED_MODAL.UPLOAD_FILE')}
      onClose={closeUploadModal}
      onSave={addDocument}
      saveLabel={t('BOM_LIBRARY.IMPORTED_MODAL.ADD')}
      saveLoading={loader}
    >
      <UploadDocuments setShowGradingGroupError={() => {}} fromLibrary hideName ref={docRef} accept=".xlsx, .xls" fromGrading />
    </BombiixModal>
  );
}

export default ImportModal;
